import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, Transition as _Transition, createElementBlock as _createElementBlock } from "vue"

import { RoleEnum } from "@/generated/graphql";
import useRoles from "@/hooks/useRole";
import { Capacitor } from "@capacitor/core";
import {
  IonItem,
  IonInput,
  IonTextarea,
  IonNote,
  IonLabel,
  InputCustomEvent,
  TextareaCustomEvent,
} from "@ionic/vue";
import { computed, withDefaults } from "vue";


const __default__ = {
  name: "BaseInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: { default: "" },
    disabled: { type: Boolean, default: false },
    placeholder: { default: "" },
    errorMessage: {},
    required: { type: Boolean },
    label: {},
    type: { default: "text" },
    rows: { default: 1 },
    maxLength: {},
    autoGrow: { type: Boolean, default: false },
    fromSettings: { type: Boolean, default: false },
    fontLatoBold: { type: Boolean, default: false },
    whiteInput: { type: Boolean, default: false },
    grayInput: { type: Boolean }
  },
  emits: ["update:value", "change"],
  setup(__props: any, { emit: emits }) {

const props = __props;



const { role } = useRoles();


const inputValue = computed({
  get() {
    return props.value;
  },
  set(updatedValue: string) {
    emits("update:value", updatedValue);
  },
});

const inputChangeHandle = (event: InputCustomEvent | TextareaCustomEvent) => {
  emits("change", event.detail.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-input-container", { 
    'form-row__input' : (_unref(role) === _unref(RoleEnum).Trainer || _unref(role) === _unref(RoleEnum).User || _unref(role) === _unref(RoleEnum).FacilityOwner),
    'form-row__input__web': _ctx.fromSettings, 
    'font-lato': (_unref(role) === _unref(RoleEnum).User && _ctx.fromSettings),
    'font-lato-bold': _ctx.fontLatoBold,
    'white-input': _ctx.whiteInput,
    'gray-input': _ctx.grayInput
  }])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createBlock(_unref(IonLabel), {
          key: 0,
          class: "label"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "border" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonItem), {
          disabled: _ctx.disabled,
          class: _normalizeClass([{ 'ion-invalid': _ctx.errorMessage }, "input-container"]),
          lines: "none"
        }, {
          default: _withCtx(() => [
            (_ctx.rows <= 1)
              ? (_openBlock(), _createBlock(_unref(IonInput), {
                  key: 0,
                  modelValue: inputValue.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
                  type: _ctx.type,
                  placeholder: _ctx.placeholder,
                  required: _ctx.required,
                  maxlength: _ctx.maxLength,
                  onIonChange: inputChangeHandle
                }, null, 8, ["modelValue", "type", "placeholder", "required", "maxlength"]))
              : (_openBlock(), _createBlock(_unref(IonTextarea), {
                  key: 1,
                  "auto-grow": _ctx.autoGrow,
                  modelValue: inputValue.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputValue).value = $event)),
                  placeholder: _ctx.placeholder,
                  required: _ctx.required,
                  maxlength: _ctx.maxLength,
                  rows: _ctx.rows,
                  onIonChange: inputChangeHandle
                }, null, 8, ["auto-grow", "modelValue", "placeholder", "required", "maxlength", "rows"]))
          ]),
          _: 1
        }, 8, ["disabled", "class"])
      ]),
      _: 1
    }),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.errorMessage)
          ? (_openBlock(), _createBlock(_unref(IonNote), { key: 0 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})